<template>
  <div class="Detail">
    <!-- 面包屑导航 -->
    <div class="crumbs">
      <div class="crumbs_font left_10">当前位置:</div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="crumbs_font"
          ><span @click="jup()">网校首页</span></el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/' }" class="crumbs_font"
          >打卡首页</el-breadcrumb-item
        >
        <!-- 面包屑显示当前训练营 -->
        <el-breadcrumb-item
          class="crumbs_font"
          v-if="detailInfo != null"
          :to="{ path: `/Detail/apply/${detailInfo.detail.camp_id}` }"
          >{{ detailInfo.detail.name }}</el-breadcrumb-item
        >
        <el-breadcrumb-item
          class="crumbs_font"
          v-if="detailInfo != null && detailInfo.study"
          >开始学习</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>


<script>
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      // 是否在开始学习页面
      study: false,
    };
  },
  methods: {
    ...mapMutations(["login"]),
    jup() {
      window.location.href = window.location.origin;
    },
  },
  computed: {
    ...mapState(["detailMianbao"]),
    //
    detailInfo() {
      if (this.detailMianbao != null) {
        return this.detailMianbao;
      } else {
        return null;
      }
    },
  },
  watch: {
    $route: {
      handler(to) {
        console.log("补丁触发");
        let router = to.path;
        let Reg = /(\/Detail\/apply)/;
        console.log(router.search(Reg));
        if (router.search(Reg) == -1) {
          console.log("去除")
          this.$(".Detail").css({ width: "" });
        } 
      },
      immediate: true, //第一次就执行
    },
  },
  async created() {
    // 分销参数
    let distrid = this.$route.query.distrid;
    if (distrid != null) {
      sessionStorage.setItem("distrid", distrid);
    } else {
      sessionStorage.removeItem("distrid");
    }
    // token参数
    let url = window.location.origin;
    url = url + "/getInfo";
    await this.$axios
      .get(url, {
        params: {
          distrid: distrid,
        },
      })
      .then((doc) => {
        if (doc.token != null) {
          // this.F5 = false
          localStorage.setItem("token", doc.token);
          localStorage.setItem("agency_id", doc.agency_id);
          this.login(doc);
          // var that = this
          // setTimeout(()=>{
          //   that.F5 = true
          // },150)
        } else {
          localStorage.setItem("agency_id", doc.agency_id);
          localStorage.removeItem("token");
          this.login(doc);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script> 

<style lang="less" scoped>
.Detail {
  padding-bottom: 4.125rem;
  background-color: #f9f9f9;
  margin: auto;
  //   width: 81.9375rem;
  width: 76.9375rem;
  // overflow: hidden;
  //   面包屑导航
  .crumbs {
    position: relative;
    z-index: 9;
    margin: 2rem 0 1.125rem 0;
    display: flex;
    flex-direction: row;
    justify-items: center;
    align-items: center;
    .crumbs_font {
      cursor: pointer;
    }
    .crumbs_font,
    .is-link {
      font-size: 0.75rem;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #9e9f9b;
    }
    .left_10 {
      margin-right: 0.625rem;
    }
    /deep/ .el-breadcrumb {
      .el-breadcrumb__inner {
        font-size: 0.75rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #9e9f9b;
      }
      .el-breadcrumb__inner:hover {
        color: #e9665f;
      }
      .crumbs_font:last-child {
        .el-breadcrumb__inner {
          color: #e9665f;
        }
      }
    }
  }
}
</style>